<template>
    <div class="consumption-wrap-energy">
        <div class="search_wrap">
            <el-form
                :inline="true"
                :model="searchForm"
                class="leader-style-form"
                label-width="120px"
            >
                <el-form-item label="时间">
                    <el-date-picker
                        v-model="searchForm.startM"
                        type="month"
                        placeholder="开始日期"
                        value-format="yyyy-MM"
                        format="yyyy-MM"
                        :picker-options="pickerOptions"
                        :clearable="false"
                        :editable="false"
                    ></el-date-picker>
                    <span
                        style="color: #fff;display: inline-block;margin-left: 20px;font-size: 16px;"
                        >至</span
                    >
                    <el-date-picker
                        v-model="searchForm.endM"
                        type="month"
                        placeholder="结束日期"
                        value-format="yyyy-MM"
                        format="yyyy-MM"
                        :picker-options="pickerOptions"
                        :clearable="false"
                        :editable="false"
                        style="margin-left: 20px"
                    ></el-date-picker>
                </el-form-item>
                <el-form-item style="float: right">
                    <el-button class="leader-common-button" @click="search"
                        >查询
                    </el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="consumption-container">
            <div class="consump-echarts">
                <v-chart
                    :auto-resize="true"
                    :options="energyConsumpBar"
                    ref="energyConsumpBar"
                    theme="ovilia-green"
                    @click="consumpClick"
                />
            </div>
        </div>
    </div>
</template>
<script>
import "echarts/lib/chart/bar";
import "echarts/lib/chart/sankey";
import "echarts/lib/chart/line";
import "echarts/lib/chart/pie";
import "echarts/lib/chart/bar";
import "echarts/lib/chart/treemap";
import "echarts/lib/component/tooltip";
import "echarts/lib/component/title";
import "echarts/lib/component/legend";
import "echarts/lib/component/toolbox";
import "echarts/lib/component/markPoint";
import "echarts/lib/component/graphic";
import * as api from "@/http/api.js";
import {
    departmentColor,
    sameAndCircle,
    energyColor
} from "@/utils/chart-color.js";
import utils from "@/utils/utils";
export default {
    data() {
        return {
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() > Date.now();
                }
            },
            searchForm: {
                year: "",
                startM: "",
                endM: ""
            },

            x_list: [],
            y_list: [],
            selectMonth: "",
            treeMaps: [],
            data: [],
            links: [],
            // color:["#3ef5a3", "#fff", "#ff933e"],
            color: ["#ff933e", "#fff", "#3ef5a3"]
        };
    },
    created() {
        this.getSysDate();
    },
    methods: {
        search() {
            this.getSankeyList();
        },
        getSysDate() {
            api.getSysDate1().then(res => {
                if (res && res.error_code === "0") {
                    this.searchForm.time = res.bus_json.sysdate3;
                    this.searchForm.year = res.bus_json.sysdate4;
                    this.searchForm.startM =
                        this.searchForm.year -
                        1 +
                        res.bus_json.sysdate3.slice(4);
                    this.searchForm.endM = res.bus_json.sysdate3;
                    // this.searchForm.startM = this.searchForm.year - 1 + '-01';
                    // this.searchForm.endM = this.searchForm.year - 1 + '-12';

                    this.getSankeyList();
                }
            });
        },
        getSankeyList() {
            api.getSankeyList({
                start_show_day: this.searchForm.startM,
                end_show_day: this.searchForm.endM
            }).then(res => {
                if (res && res.error_code === "0") {
                    this.data = res.bus_json.dataList;
                    this.links = res.bus_json.linksList;
                }
            });
        },
        consumpClick() {}
    },
    computed: {
        energyConsumpBar() {
            const option = {
                title: {
                    left: "center",
                    textStyle: {
                        color: utils.getFontColor()
                    }
                },
                tooltip: {
                    trigger: "item",
                    triggerOn: "mousemove",
                    formatter: function(params) {
                        // return params.name + '<br/>' + params.value + 'tce';
                        return (
                            params.name +
                            "<br/>" +
                            parseFloat(params.value).toFixed(2) +
                            "tce"
                        );
                    }
                },
                legend: {
                    show: false
                },
                // color: this.color,
                series: {
                    top: "5%",
                    left: "5%",
                    right: "10%",
                    bottom: "5%",
                    label: {
                        color: utils.getFontColor()
                    },
                    type: "sankey",
                    layout: "none",
                    emphasis: {
                        focus: "adjacency"
                    },
                    lineStyle: {
                        curveness: 0.5
                    },
                    data: this.data,
                    links: this.links
                    // data: [{
                    //     name: "电",
                    //     itemStyle:{
                    //         color:"#db2222"
                    //     }
                    // }, {
                    //     name: "3#变",
                    //     itemStyle:{
                    //         color:"#345170"
                    //     }
                    // }, {
                    //     name: "1#主变 4#主变",
                    //     itemStyle:{
                    //         color:"#258745"
                    //     }
                    // }, {
                    //     name: "2#变 5#主变"
                    // }],
                    // links: [{
                    //     source: "电",
                    //     target: "1#主变 4#主变",
                    //     value: 5
                    // }, {
                    //     source: "电",
                    //     target: "2#变 5#主变",
                    //     value: 3
                    // }, {
                    //     source: "电",
                    //     target: "3#变",
                    //     value: 8
                    // }]
                }
            };
            return option;
        }
    }
};
</script>
<style lang="scss">
.consumption-wrap-energy {
    // box-sizing: border-box;
    padding: 0 pxRem(20px) pxRem(10px) pxRem(20px);
    // background: transparent;
    width: 100%;
    height: px2Rem(800px);
    overflow: auto;

    .search_wrap {
        margin-top: pxRem(20px);
        margin-bottom: pxRem(20px);
        width: 100%;

        .time_btn {
            background: #29b85e;
            color: #fff;
        }
    }

    .consumption-container {
        width: 100%;
        height: 85%;
        margin-top: pxRem(80px);
        background-size: 100% 100%;

        .consump-echarts {
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;

            .echarts {
                width: 100%;
                height: 100%;
            }
        }
    }
}
</style>
